export default __webpack_public_path__ + "static/media/Moon.29f7c01b.svg";